const PERMISSION_KEY= "core:billing_detail";
const PAGE_URL = {
    BILLING_DETAIL_PAGE: "/admin/core/billing-detail"
}

export {PERMISSION_KEY, PAGE_URL}

